// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Counter-container {
    text-align: center;
    margin-top: 50px;
}

.Counter-btn {
    background-color: #61dafb;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    margin: 0 10px;
    cursor: pointer;
}

.Counter-value {
    display: inline-block;
    width: 120px;
    font-size: 24px;
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./packages/react-18-app/src/Counter.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".Counter-container {\n    text-align: center;\n    margin-top: 50px;\n}\n\n.Counter-btn {\n    background-color: #61dafb;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    padding: 10px 20px;\n    margin: 0 10px;\n    cursor: pointer;\n}\n\n.Counter-value {\n    display: inline-block;\n    width: 120px;\n    font-size: 24px;\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
